// Intentionally empty — replaces Next.js built-in polyfills.
// Modern browsers (Chrome 93+, Safari 15.4+) natively support all required APIs.
